export const MANIFEST_VIEW_URL = 'schedule/manifest'
export const MANIFEST_VIEW_ERROR = 'MANIFEST_VIEW_ERROR'
export const MANIFEST_VIEW_LOADING = 'MANIFEST_VIEW_LOADING'
export const MANIFEST_VIEW_SUCCESS = 'MANIFEST_VIEW_SUCCESS'